var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoinsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1625_79814)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.582 6.66211C19.582 8.31971 18.9236 9.90942 17.7514 11.0815C16.5793 12.2536 14.9896 12.9121 13.332 12.9121C13.1872 12.9121 13.0425 12.9037 12.8987 12.8871C11.3971 12.7868 9.98274 12.1455 8.9178 11.0821C7.85286 10.0187 7.20952 8.60525 7.10703 7.10378C7.0904 6.95714 7.08205 6.80968 7.08203 6.66211C7.08203 5.00451 7.74051 3.41479 8.91261 2.24269C10.0847 1.07059 11.6744 0.412109 13.332 0.412109C14.9896 0.412109 16.5793 1.07059 17.7514 2.24269C18.9236 3.41479 19.582 5.00451 19.582 6.66211Z",
    fill: "currentColor",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.332 0.41211C11.6744 0.41211 10.0847 1.07059 8.91261 2.24269C7.74051 3.4148 7.08203 5.00451 7.08203 6.66211C7.08207 6.80968 7.09042 6.95714 7.10703 7.10378C7.2073 8.58872 7.83783 9.9882 8.8837 11.0471L17.717 2.21378C16.55 1.05868 14.974 0.411164 13.332 0.41211Z",
    fill: "currentColor",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9035 12.8872C12.9965 14.1594 12.6982 15.4296 12.0488 16.5275C11.3993 17.6254 10.4297 18.4985 9.26995 19.0297C8.1102 19.5609 6.81577 19.7249 5.56023 19.4995C4.30468 19.2742 3.14803 18.6704 2.24539 17.769C1.34275 16.8677 0.737266 15.7119 0.510124 14.4567C0.282982 13.2015 0.445044 11.9068 0.974579 10.7463C1.50411 9.5858 2.3758 8.61493 3.47277 7.96389C4.56973 7.31286 5.83952 7.01277 7.11187 7.10387C7.21437 8.60534 7.8577 10.0188 8.92264 11.0822C9.98758 12.1456 11.4019 12.7869 12.9035 12.8872Z",
    fill: "currentColor",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.11009 7.10355C5.84378 7.01375 4.58015 7.31169 3.48734 7.95774C2.39454 8.60378 1.52437 9.56729 0.992641 10.7201C0.460909 11.8728 0.292825 13.1602 0.510754 14.4108C0.728683 15.6615 1.32229 16.8161 2.21259 17.7211L8.88676 11.0469C7.84089 9.98797 7.21036 8.5885 7.11009 7.10355Z",
    fill: "currentColor",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.582 6.66211C19.582 8.31971 18.9236 9.90942 17.7514 11.0815C16.5793 12.2536 14.9896 12.9121 13.332 12.9121C13.1872 12.9121 13.0425 12.9037 12.8987 12.8871C11.3971 12.7868 9.98274 12.1455 8.9178 11.0821C7.85286 10.0187 7.20952 8.60525 7.10703 7.10378C7.0904 6.95714 7.08205 6.80968 7.08203 6.66211C7.08203 5.00451 7.74051 3.41479 8.91261 2.24269C10.0847 1.07059 11.6744 0.412109 13.332 0.412109C14.9896 0.412109 16.5793 1.07059 17.7514 2.24269C18.9236 3.41479 19.582 5.00451 19.582 6.66211V6.66211Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9035 12.8872C12.9965 14.1594 12.6982 15.4296 12.0488 16.5275C11.3993 17.6254 10.4297 18.4985 9.26995 19.0297C8.1102 19.5609 6.81577 19.7249 5.56023 19.4995C4.30468 19.2742 3.14803 18.6704 2.24539 17.769C1.34275 16.8677 0.737266 15.7119 0.510124 14.4567C0.282982 13.2015 0.445044 11.9068 0.974579 10.7463C1.50411 9.5858 2.3758 8.61493 3.47277 7.96389C4.56973 7.31286 5.83952 7.01277 7.11187 7.10387C7.21437 8.60534 7.8577 10.0188 8.92264 11.0822C9.98758 12.1456 11.4019 12.7869 12.9035 12.8872V12.8872Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25391 11.2454V10.4121",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5012 11.2441H5.81287C5.55323 11.2443 5.30174 11.3348 5.10154 11.5002C4.90134 11.6655 4.7649 11.8953 4.71563 12.1503C4.66636 12.4052 4.70733 12.6693 4.83151 12.8973C4.95568 13.1253 5.15533 13.3031 5.3962 13.4L7.1162 14.0883C7.35707 14.1852 7.55672 14.3629 7.68089 14.591C7.80507 14.819 7.84604 15.0831 7.79677 15.338C7.7475 15.5929 7.61106 15.8228 7.41086 15.9881C7.21066 16.1534 6.95917 16.244 6.69953 16.2441H5.0012",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25391 17.0775V16.2441",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3398 4.16146V3.32812",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5832 4.16211H12.8949C12.6353 4.16229 12.3838 4.25281 12.1836 4.41814C11.9834 4.58347 11.8469 4.8133 11.7977 5.06823C11.7484 5.32315 11.7894 5.58727 11.9135 5.81529C12.0377 6.04331 12.2374 6.22102 12.4782 6.31794L14.1982 7.00628C14.4391 7.10319 14.6388 7.2809 14.7629 7.50893C14.8871 7.73695 14.9281 8.00107 14.8788 8.25599C14.8295 8.51092 14.6931 8.74075 14.4929 8.90608C14.2927 9.07141 14.0412 9.16193 13.7816 9.16211H12.0832",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3398 9.99544V9.16211",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1625_79814"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "currentColor"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinsIcon);
export default __webpack_public_path__ + "static/media/coins_icon.e6654b76ec776bac336a93609f46e2a1.svg";
export { ForwardRef as ReactComponent };